function ButtonLoading() {
    return (<>
        <img className="ms-1" width={20} height={20} src={process.env.PUBLIC_URL + '/loading_gray.gif'} alt="description" />
    </>);
}

export default ButtonLoading;